import { ref } from 'vue'
import { defineStore } from 'pinia';
import { i18n } from '@/main.js';


export const useBreadcrumbStore = defineStore('breadcrumb', () => {

  const { t, locale } = i18n.global;

  const lg = locale == "en" ? "/en" : "";

  const breadcrumb = ref([
    { ID: 1, text: t('breadcrumb.homepage'), href: `https://www.uma.pt${lg}`, isRoute: false },
    { ID: 2, text: t('breadcrumb.sobre'), href: `https://www.uma.pt${lg}/sobre`, isRoute: false },
    { ID: 3, text: t('breadcrumb.admin'), href: `https://www.uma.pt${lg}/sobre/orgaos-de-governo/`, isRoute: false },
    { ID: 4, text: t('breadcrumb.sigla'), href: `https://www.uma.pt${lg}/sobre/orgaos-de-governo/conselho-geral`, isRoute: false },
  ]);

  const initialSize = breadcrumb.value.length

  const replaceSection = (title,path) => {
    if(path == "/"){
      if(breadcrumb.value.length > initialSize){
        removeLastSection();
      }
    }else{
      breadcrumb.value[initialSize] = { ID: initialSize+1, text: title, path: path, isRoute: true }
    }
  }

  const addSection = (title,path) => {
    breadcrumb.value[breadcrumb.value.length] = { ID: breadcrumb.value.length+1, text: title, path: path, isRoute: true }
  }

  const removeLastSection = () => {
    if (breadcrumb.value.length > initialSize) {
      breadcrumb.value.pop();
    }
  }

  return {
    removeLastSection,
    addSection,
    replaceSection,
    breadcrumb
  }

})
